import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-299e9a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "breadcrumb" }
const _hoisted_2 = { class: "block" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "customDate" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, " 自定义时间:", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查询")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RangePicker = _resolveComponent("RangePicker")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerList, (item) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (_ctx.handlerClick(item.url)),
            key: item.id,
            class: _normalizeClass(['tab', _ctx.curRouter === item.url ?'active':''])
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
          default: _withCtx(() => [
            _createVNode(_component_RangePicker, {
              format: "YYYY-MM-DD",
              value: _ctx.customDate,
              placeholder: ['开始日期', '结束日期'],
              onChange: _ctx.onChange
            }, null, 8, ["value", "onChange"])
          ]),
          _: 1
        }, 8, ["locale"]),
        _createElementVNode("span", null, [
          _createVNode(_component_Button, {
            type: "primary",
            onClick: _ctx.search
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.customDateShow]
      ])
    ])
  ]))
}